import { DocumentServicesObject } from '@wix/document-services-types';

import {
  isDuplicatePrefixError,
  isInvalidCharError,
  sanitizeRouterPrefix,
  validateRouterPrefix,
} from './validations';

const MAX_SUFFIX_ATTEMPTS = 9;

export function findAvailableRouterPrefix({
  appDefinitionId,
  documentServices,
  preferredPrefix,
}: {
  appDefinitionId: string;
  documentServices: DocumentServicesObject;
  preferredPrefix: string;
}): string | undefined {
  for (let i = 1; i <= MAX_SUFFIX_ATTEMPTS; i++) {
    const candidate = `${preferredPrefix}-${i}`;
    const result = validateRouterPrefix(
      documentServices,
      appDefinitionId,
      candidate,
    );

    if (result.valid) {
      return candidate;
    }

    if (!isDuplicatePrefixError(result.errorCode)) {
      return undefined;
    }
  }

  return undefined;
}

export function getValidRouterPrefix(
  documentServices: DocumentServicesObject,
  appDefinitionId: string,
  preferredPrefix: string,
  errorCode: number,
): string | undefined {
  if (!isInvalidCharError(errorCode) && !isDuplicatePrefixError(errorCode)) {
    return undefined;
  }

  const prefix = isInvalidCharError(errorCode)
    ? sanitizeRouterPrefix(preferredPrefix)
    : preferredPrefix;

  if (!prefix) {
    return undefined;
  }

  const prefixCheck = validateRouterPrefix(
    documentServices,
    appDefinitionId,
    prefix,
  );

  if (prefixCheck.valid) {
    return prefix;
  }

  if (!isDuplicatePrefixError(prefixCheck.errorCode)) {
    return undefined;
  }

  return findAvailableRouterPrefix({
    appDefinitionId,
    documentServices,
    preferredPrefix: prefix,
  });
}
